<template>

<section class="section">
<div class="container">

<h5 class="title is-5">
    ОБЩА ИНФОРМАЦИЯ ЗА ПРЕДЛАГАНИТЕ ОТ „СОФИЯ КОМЕРС КРЕДИТ ГРУП” АД КРЕДИТИ ЗА НЕДВИЖИМИ ИМОТИ НА ПОТРЕБИТЕЛИ
</h5>

<div id="general-info" class="pre">
  {{ generalInfoText }}
</div>

</div>
</section>
</template>

<script>
export default {
  name: 'GeneralInfo',
  data () {
    return {
      generalInfoText: 'Зарежда се ...'
    }
  },
  beforeCreate () {
    const axios = this.$axios.create({
      params: { api_key: this.$_config.API_KEY },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true
    })

    axios
      .get('https://www.creditgroup.cc/agent-app/api/ipo/policies/general-info-text')
      .then(response => {
        this.generalInfoText = response.data
      })
      .catch(error => {
        console.error(error)
      })
  },
  mounted () {
    this.$nextTick(() => {
      this.$scrollTo('body', 500, {offset: -0})
    })
  }
}
</script>

<style lang="stylus" scoped>
.pre
  white-space pre-wrap       /* css-3 */
  white-space -moz-pre-wrap  /* Mozilla, since 1999 */
  white-space -pre-wrap      /* Opera 4-6 */
  white-space -o-pre-wrap    /* Opera 7 */
  word-wrap break-word       /* Internet Explorer 5.5+ */
  text-align justify
  // width 94vw
  // margin auto

@media(min-width 768px)
  .pre
    width 70vw
    margin auto
</style>



// WEBPACK FOOTER //
// src/components/policies/GeneralInfo.vue